module.exports = __webpack_public_path__ + "static/media/01.b7fbb714.jpg";